var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "customer",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8917 33.9044C4.87828 30.5968 3.04504 26.2301 3.04504 21.4422C3.04504 11.1166 11.5668 2.74609 22.0789 2.74609C32.591 2.74609 41.1128 11.1166 41.1128 21.4422C41.1128 28.7431 36.8508 35.064 30.6385 38.1418C26.8377 40.1235 22.5016 41.2461 17.8986 41.2461C12.2586 41.2461 7.01923 39.5606 2.67432 36.6748C2.67432 36.6748 5.58801 36.357 7.89095 33.9052L7.8917 33.9044ZM31.0197 30.6951C35.944 25.7709 35.944 17.7872 31.0197 12.8629C28.7363 10.5797 25.7951 9.35583 22.8061 9.19019V9.18945C22.7159 6.94688 23.923 5.43237 23.9289 5.42499L23.9283 5.42511L23.9291 5.42406C20.4938 6.08767 17.2134 7.74964 14.5533 10.4097C12.5133 12.4497 11.0607 14.8546 10.1948 17.4142C10.3208 17.0802 10.4613 16.7506 10.6162 16.4261C10.4376 16.882 10.2761 17.348 10.13 17.8246C8.6879 22.2025 9.70581 27.2134 13.1875 30.6951C18.1118 35.6194 26.0955 35.6194 31.0197 30.6951Z",
    fill: "url(#paint0_linear_1248_838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7024 20.4829V22.0494V23.0928C15.7024 24.1343 16.5466 24.9786 17.5883 24.9786C18.6298 24.9786 19.4739 24.1343 19.4739 23.0928V22.0478V20.4829C19.4739 19.4415 18.6298 18.597 17.5883 18.597C16.5466 18.597 15.7024 19.4415 15.7024 20.4829Z",
    fill: "#00058B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0369 20.4829V22.0494V23.0928C25.0369 24.1343 25.8812 24.9786 26.9226 24.9786C27.9641 24.9786 28.8085 24.1343 28.8085 23.0928V22.0478V20.4829C28.8085 19.4415 27.9641 18.597 26.9226 18.597C25.8812 18.597 25.0369 19.4415 25.0369 20.4829Z",
    fill: "#00058B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1248_838",
    x1: 16.6944,
    y1: -5.42608,
    x2: 51.1525,
    y2: 9.07869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00058B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#187BF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.3af442c68607678876fb91e67a56caad.svg";
export { ForwardRef as ReactComponent };